// extracted by mini-css-extract-plugin
module.exports = {"sectionProcess":"Repair_sectionProcess_15Ekq","contactBox":"Repair_contactBox_qnCnj","formDetail":"Repair_formDetail_3vi6o","sectionApplication":"Repair_sectionApplication_2_ubY"};